import React from "react";
import classNames from "classnames";
import getClassNameFactory from "../../../../utilities/classNames";

var Column = function Column(_ref) {
  var children = _ref.children,
      hiddenOnMobile = _ref.hiddenOnMobile;
  var getClassName = getClassNameFactory("SiteHeaderColumn");
  return /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      modifiers: classNames({
        hiddenOnMobile: hiddenOnMobile
      })
    })
  }, children);
};

Column.displayName = "SiteHeader.Column";
export default Column;